import { get } from '.';

export function GetLlmAssessments(options = {}) {
    return get<any>("/app/api/llm_assessments", options);
}

export function FindLlmAssessment(llmAssessmentKey: string) {
    return get<any>("/app/api/llm_assessments/" + llmAssessmentKey);
}